import { atom } from '@reatom/framework';
export class Observable {
    __INTERNAL_DO_NOT_USE_ATOM__;
    constructor(a) {
        this.__INTERNAL_DO_NOT_USE_ATOM__ = a;
    }
}
export function createObservable(value) {
    return new Observable(atom(value));
}
/**
 * Structural check instead of `instanceof`: the bundler may end up with several
 * copies of the Observable class (e.g. one per chunk), which breaks class identity.
 */
export function isObservable(value) {
    return typeof value === 'object' && value !== null && '__INTERNAL_DO_NOT_USE_ATOM__' in value;
}
export function createObservableFromAtom(a) {
    return new Observable(a);
}
